import { render, staticRenderFns } from "./todoMgmt.vue?vue&type=template&id=681370a2&scoped=true&"
import script from "./todoMgmt.vue?vue&type=script&lang=js&"
export * from "./todoMgmt.vue?vue&type=script&lang=js&"
import style0 from "./todoMgmt.vue?vue&type=style&index=0&id=681370a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681370a2",
  null
  
)

export default component.exports